import type { SmartOLTReportsOutage, SmartOLTReportsScatterPoint } from "../../../services/smartolt.service.ts"
import { SMARTOLT_PATHS } from "../smartoltNav.ts"

export type ReportsTab = "signal" | "status" | "outages" | "faults" | "alarms" | "pon"

export const REPORTS_TABS: { id: ReportsTab; label: string }[] = [
  { id: "signal", label: "Signal strength" },
  { id: "status", label: "Network Status" },
  { id: "outages", label: "Outages" },
  { id: "faults", label: "Faults" },
  { id: "alarms", label: "Alarms" },
  { id: "pon", label: "Pon Port Avg. Signal" },
]

export function configuredHref(params: Record<string, string>) {
  const query = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value) query.set(key, value)
  })
  const qs = query.toString()
  return qs ? `${SMARTOLT_PATHS.configured}?${qs}` : SMARTOLT_PATHS.configured
}

export function formatSignal(value?: number | null) {
  if (value == null || Number.isNaN(value)) return "-"
  return `${value.toFixed(2)}dB`
}

export function formatDistance(meters?: number | null) {
  if (meters == null || Number.isNaN(meters)) return "-"
  return `${Math.round(meters)}m`
}

export function scatterColor(point: SmartOLTReportsScatterPoint) {
  if (point.status_kind !== "online") return "#A3A3A3"
  if (point.band === "bad") return "#EF4444"
  if (point.band === "warning") return "#EAB308"
  return "#22C55E"
}

export function outageIconTone(row: SmartOLTReportsOutage) {
  if (row.status_kind === "los") return "text-rose-400"
  if (row.status_kind === "power") return "text-amber-400"
  return "text-slate-400"
}

export function outageCauseTone(row: SmartOLTReportsOutage) {
  if (row.cause === "Fiber Path") return "font-semibold text-rose-600"
  if (row.cause === "Electricity") return "font-semibold text-amber-600"
  return "font-semibold text-slate-700"
}

export function serviceBadgeClass(status: string) {
  if (status === "running") return "bg-emerald-50 text-emerald-700 border border-emerald-200 font-semibold"
  if (status === "down") return "bg-rose-50 text-rose-700 border border-rose-200 font-semibold"
  if (status === "configured") return "bg-sky-50 text-sky-700 border border-sky-200 font-semibold"
  return "bg-slate-100 text-slate-700 border border-slate-200 font-semibold"
}

export function formatServiceStatus(status: string) {
  if (status === "api_unavailable") return "API unavailable"
  if (status === "configured") return "Configured"
  if (status === "running") return "Running"
  if (status === "down") return "Down"
  return "Unknown"
}
